import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TermsAndConditions = () => {
  const navigate = useNavigate();
  const [accepted, setAccepted] = useState(false);

  const handleAccept = () => {
    if (accepted) {
      // Store acceptance in localStorage or send to backend
      localStorage.setItem('termsAccepted', 'true');
      navigate('/home');
    }
  };

  return (
    <div className="container-fluid p-0 min-vh-100 bg-light">
      {/* Header */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary shadow">
        <div className="container">
          <button 
            className="btn btn-link text-white me-2"
            onClick={() => navigate(-1)}
          >
            <i className="bi bi-arrow-left fs-4"></i>
          </button>
          <h1 className="navbar-brand mb-0 h1 fs-4">Terms & Conditions</h1>
          <div className="ms-auto">
            <span className="text-white small">Read and accept to continue</span>
          </div>
        </div>
      </nav>

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card shadow-lg border-0 rounded-4">
              <div className="card-body p-4 p-md-5">
                {/* Title */}
                <div className="text-center mb-5">
                  <div className="mb-4">
                    <i className="bi bi-file-text text-primary display-4"></i>
                  </div>
                  <h2 className="fw-bold text-primary mb-3">Terms & Conditions</h2>
                  <p className="text-muted">Please read the following terms carefully before proceeding</p>
                </div>

                {/* Important Notice */}
                <div className="alert alert-warning mb-4">
                  <div className="d-flex">
                    <i className="bi bi-exclamation-triangle-fill me-3 fs-4"></i>
                    <div>
                      <h5 className="alert-heading mb-2">Important Notice</h5>
                      <p className="mb-0">
                        These terms govern your use of our algorithmic trading services. By accepting, you agree to be bound by these terms.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Terms Content */}
                <div className="terms-content mb-5">
                  <div className="mb-4">
                    <h4 className="fw-bold text-dark mb-3">Investment Terms & Conditions</h4>
                    
                    <div className="card border-light shadow-sm mb-3">
                      <div className="card-body">
                        <div className="d-flex align-items-start">
                          <div className="me-3">
                            <span className="badge bg-primary rounded-circle d-flex align-items-center justify-content-center" 
                                  style={{ width: '30px', height: '30px' }}>
                              1
                            </span>
                          </div>
                          <div>
                            <h5 className="fw-bold text-dark">Profit Sharing Fee</h5>
                            <p className="mb-0">
                              You will have to pay the company a fee of <strong>10% of your profit</strong> at the end of each calendar month. This fee is applicable only on profitable trades and calculated on net realized profits.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card border-light shadow-sm mb-3">
                      <div className="card-body">
                        <div className="d-flex align-items-start">
                          <div className="me-3">
                            <span className="badge bg-primary rounded-circle d-flex align-items-center justify-content-center" 
                                  style={{ width: '30px', height: '30px' }}>
                              2
                            </span>
                          </div>
                          <div>
                            <h5 className="fw-bold text-dark">No Direct Charges</h5>
                            <p className="mb-0">
                              No charges from the company will be debited from your demat account. All fees will be invoiced separately and payable through designated payment channels. Your trading capital remains untouched for fee deductions.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card border-light shadow-sm mb-3">
                      <div className="card-body">
                        <div className="d-flex align-items-start">
                          <div className="me-3">
                            <span className="badge bg-primary rounded-circle d-flex align-items-center justify-content-center" 
                                  style={{ width: '30px', height: '30px' }}>
                              3
                            </span>
                          </div>
                          <div>
                            <h5 className="fw-bold text-dark">Company Legal Information</h5>
                            <p className="mb-2">
                              Our company operates under <strong>Section 115BBH</strong> of the Income Tax Act, 1961.
                            </p>
                            <div className="bg-light p-3 rounded">
                              <p className="mb-1"><strong>Company CIN:</strong> U67100MH2019PTC331358</p>
                              <p className="mb-0"><strong>Registration Type:</strong> Private Limited Company</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card border-light shadow-sm">
                      <div className="card-body">
                        <div className="d-flex align-items-start">
                          <div className="me-3">
                            <span className="badge bg-primary rounded-circle d-flex align-items-center justify-content-center" 
                                  style={{ width: '30px', height: '30px' }}>
                              4
                            </span>
                          </div>
                          <div>
                            <h5 className="fw-bold text-dark">Trading Operations</h5>
                            <p className="mb-0">
                              The trading operator system will be in the hands of the broker, using <strong>robotic and algorithmic trading</strong> systems. All trades are executed automatically based on pre-defined algorithms without manual intervention. You acknowledge that trading involves market risks and past performance doesn't guarantee future results.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Additional Terms Section */}
                  <div className="mb-4">
                    <h4 className="fw-bold text-dark mb-3">Additional Terms</h4>
                    
                    <div className="accordion" id="additionalTerms">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#riskDisclosure">
                            <i className="bi bi-shield-exclamation me-2"></i>
                            Risk Disclosure
                          </button>
                        </h2>
                        <div id="riskDisclosure" className="accordion-collapse collapse show">
                          <div className="accordion-body">
                            <ul className="mb-0">
                              <li>Trading in securities markets involves substantial risk of loss</li>
                              <li>Algorithmic trading may execute trades rapidly in response to market conditions</li>
                              <li>Past performance is not indicative of future results</li>
                              <li>You should only trade with risk capital you can afford to lose</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#feeDetails">
                            <i className="bi bi-currency-rupee me-2"></i>
                            Fee Calculation Details
                          </button>
                        </h2>
                        <div id="feeDetails" className="accordion-collapse collapse">
                          <div className="accordion-body">
                            <ul className="mb-0">
                              <li>Profit calculated as net realized gains minus losses</li>
                              <li>Monthly statements will be provided by 5th of following month</li>
                              <li>Fees payable within 7 days of invoice receipt</li>
                              <li>No fees charged on losing months</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#dataPrivacy">
                            <i className="bi bi-lock me-2"></i>
                            Data Privacy & Security
                          </button>
                        </h2>
                        <div id="dataPrivacy" className="accordion-collapse collapse">
                          <div className="accordion-body">
                            <ul className="mb-0">
                              <li>Your trading data is encrypted and stored securely</li>
                              <li>We do not share your personal information with third parties</li>
                              <li>All communications are secured with SSL encryption</li>
                              <li>You have the right to request data deletion as per applicable laws</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                 
                </div>
              </div>
            </div>

          
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;